<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Devize inchise fara factura" :AdaugaVisible="false" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label='Interval' size="mini">
                    <el-date-picker size="mini" v-model="Filters.Data" type="daterange" range-separator="-"
                      start-placeholder="Data inceput" end-placeholder="Data sfarsit"
                      :picker-options="datePickerOptions" format="dd/MM/yyyy" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar inmatriculare" size="mini">
                    <el-input v-model="Filters.Numar" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Marca" size="mini">
                    <el-select v-model="Filters.Marca" @change="marcaChangeHandler()" class="full-width" filterable
                      size="mini" clearable>
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.marci" :key="'marci' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Model" size="mini">
                    <el-select v-model="Filters.Model" @change="refresh_info" class="full-width" filterable size="mini"
                      clearable :disabled="Filters.Marca == -1 || Filters.Marca == '' || !Filters.Marca">
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.modele" :key="'modele' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Tip auto" size="mini">
                    <el-select v-model="Filters.TipAuto" class="full-width">
                      <el-option label="Toate" value="-1"></el-option>
                      <el-option label="Normal" value="Normal"></el-option>
                      <el-option label="SUV" value="SUV"></el-option>
                      <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
                      <el-option label="Supercar" value="Supercar"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Nume client" size="mini">
                    <el-input v-model="Filters.Client" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar deviz" size="mini">
                    <el-input v-model="Filters.IdDeviz" clearable />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Centru productie' size="mini">
                    <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Serviciu programator' size="mini">
                    <el-select class='full-width' v-model='Filters.IdServiciuProgramator' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.servicii_programator' :key="'serviciu_programator' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Antifurt" size="mini">
                    <el-select v-model="Filters.Antifurt" class="full-width">
                      <el-option label="Toate" value="-1" />
                      <el-option label="Da" value="1" />
                      <el-option label="Nu" value="0" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Min" size="mini">
                    <el-input-number v-model="Filters.ValoareMin" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Max" size="mini">
                    <el-input-number v-model="Filters.ValoareMax" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col :md="24">
                  <el-button type="primary" size="mini" native-type="submit" @click="refresh_info()">
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()" size="mini">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>


    <el-table @expand-change="onRowExpand" :data="Results" ref="expandTable">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-card style="width: 80%; margin: 0 auto">

            <el-table :data="props.row.Devize">
              <el-table-column prop="Id" width="70px" label="#"></el-table-column>
              <el-table-column label="Data inchidere deviz">
                <template slot-scope="scope">
                  {{ scope.row.DataInchiderii | DataOraFaraSec }}
                </template>
              </el-table-column>
              <el-table-column label="Antifurt" align="right">
                <template slot-scope="scope">
                  {{ scope.row.Antifurt == 0 ? "Nu" : "Da" }}
                </template>
              </el-table-column>
              <el-table-column label="Valoare Ron" align="right">
                <template slot-scope="scope">
                  {{ scope.row.ValoareDeviz | format_money }}
                </template>
              </el-table-column>
              <el-table-column v-if="device === 'computer'" align="right" fixed="right" label="Actiuni" width="200px">
                <template slot-scope="scope">
                  <el-tooltip content="Preview">
                    <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)" />
                  </el-tooltip>
                  <el-tooltip content="Print deviz">
                    <el-button type="info" size="mini" icon="el-icon-printer" circle
                      @click="print_deviz(scope.row.Id)" />
                  </el-tooltip>
                  <el-tooltip content="Print inspectie">
                    <el-button type="warning" size="mini" icon="el-icon-printer" circle
                      @click="print_inspectie(scope.row.Id)" />
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column v-else fixed="right" label="Actiuni" width="70px" type="expand">
                <template slot-scope="scope">
                  <div class="phone-btn">
                    <el-tooltip content="Preview">
                      <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)" />
                    </el-tooltip>
                    <el-tooltip content="Print deviz">
                      <el-button type="info" size="mini" icon="el-icon-printer" circle
                        @click="print_deviz(scope.row.Id)" />
                    </el-tooltip>
                    <el-tooltip content="Print inspectie">
                      <el-button type="warning" size="mini" icon="el-icon-printer" circle
                        @click="print_inspectie(scope.row.Id)" />
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </template>
      </el-table-column>
      <el-table-column prop="NumeCompletClient" label="Client"></el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>

    </el-table>


    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
    <Previewdeviz ref="preview_deviz" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import LocalSettings from "../../backend/LocalSettings";

export default {
  name: "devize_inchise_fara_factura",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    Previewdeviz,
  },
  data() {
    return {
      loader: false,
      datePickerOptions: settings.datePickerOptions,
      status_localitate: false,
      dateDevizeVechi: '',
      expandedRows: [],
      loggedUserId: '',
      desiredUserId: '',
      device: "",
      Results: [],
      base_url: "",
      Info: {
        clienti: [],
        marci: [],
        modele: [],
      },
      Filters: {
        Data: [],
        Numar: "",
        Marca: "-1",
        Model: "-1",
        TipAuto: "-1",
        Client: "",
        IdDeviz: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Antifurt: "-1",
        ValoareMin: "",
        ValoareMax: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {

    async filtru_judet(id) {
      let response = await this.post("receptie/devize/get_localitati_filtrate", {
        IdJudet: id,
      });
      this.Info.localitati = response.localitati;
      this.status_localitate = true;
    },
    onRowExpand(expandedRows, expanded) {
      this.expandedRows = expanded;
    },

    print_inspectie(id_deviz) {
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/inspectie_finala/" + id_deviz, '_blank');

    },

    print_deviz(id_deviz) {
      // window.open("/#/deviz_produse_pdf/" + id_deviz, '_blank');
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/deviz_produse_pdf/" + id_deviz, '_blank');
    },
    async preview(id) {
      this.$refs.preview_deviz.show(id)
    },

    async get_info() {
      var response = await this.post("receptie/devize/get_info");
      this.Info.clienti = response.clienti;
      this.Info.judete = response.judete;
      this.Info.centre_productie = response.centre_productie;
      this.Info.servicii_programator = response.servicii_programator;
      this.Info.marci = response.marci;
      this.loggedUserId = response.userId;
      await this.refresh_info();
    },

    async marcaChangeHandler() {
      if (!this.Filters.Marca || this.Filters.Marca == '-1') {
        this.Info.modele = [];
        this.Filters.Model = '-1';
      }
      if (this.Filters.Marca) {
        const response = await this.post("receptie/devize/get_model_for_marca", { id_marca: this.Filters.Marca });
        if (response && response.modele) {
          this.Info.modele = response.modele;
        } else {
          this.Info.modele = [];
          this.Filters.Model = '';
        }
      }

      await this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("receptie/devize/get_devize_inchise_fara_factura", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      this.dateDevizeVechi = JSON.stringify(response.Results)

    },
    reset() {
      this.Filters = {
        Data: [],
        Numar: "",
        Marca: "-1",
        Model: "-1",
        TipAuto: "-1",
        Client: "",
        IdDeviz: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Antifurt: "-1",
        ValoareMin: "",
        ValoareMax: "",
      };
      this.refresh_info();
    },

  },

  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.device = "phone"
    } else this.device = "computer"
  },

  async mounted() {
    this.desiredUserId = null;
    if (window.location.href.includes("localhost") || window.location.href.includes("dev")) {
      this.desiredUserId = 33;
    } else {
      this.desiredUserId = 18;
    }

    await this.get_info();

    if (this.loggedUserId != this.desiredUserId) {
      this.$router.push("/no-rights");
      return;
    }

    this.select_menu_item("devize_inchise_fara_factura");
    this.base_url = settings.BASE_URL;
  },


  beforeRouteLeave(to, from, next) {
    if (this.cerere) {
      clearTimeout(this.cerere);
      this.cerere = null
    }
    next()
  },
  beforeDestroy() {
    if (this.cerere) {
      clearTimeout(this.cerere);
      this.cerere = null
    }
  }
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.btn-actiuni-group {
  display: flex;
  justify-content: center;
}

.input-element {
  width: 18%;
  margin-right: 2%;
}

.tip-persoana {
  text-align: center;
  opacity: 0.5;

}

.form-lj {
  width: 45%;
}

.group-loc {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 600px) {

  .form-lj {
    width: 100%;
  }

  .group-loc {
    flex-direction: column;
  }

  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .phone-btn {
    padding-left: 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .btn-actiuni-group {
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;

    .el-tooltip {
      margin: 0;
      padding: 0;
      width: 35px;
      height: 35px;
      margin-top: 5px;
    }
  }
}
</style>